import {animate, createTimer, JSAnimation, Timer} from "animejs";

export class AnimeTest {
    public translateXToRightAnimation: JSAnimation | undefined;
    public scaleXYAnimation: JSAnimation | undefined;
    public timer01OnCompleteDemo: Timer | undefined;
    public timer01ResolveCallback: ((value: number) => void) | null = null;
    public timer02ThenDemo: Timer | undefined;
    public timer02ResolveCallback: ((value: boolean) => void) | null = null;
    
    // Translate X to right
    public initTranslateXToRight(selector: string, containerSelector?: string): void {
        let container: HTMLElement | null;
        let element: HTMLElement | null = document.querySelector(selector);
        
        if (element !== null) {
            if (containerSelector) {
                container = document.querySelector(containerSelector) as HTMLElement;
            } else {
                container = element.parentElement as HTMLElement;
            }
        } else {
            return;
        }
        
        let containerStyle: CSSStyleDeclaration = window.getComputedStyle(container);
        let paddingLeft: number = parseFloat(containerStyle.paddingLeft);
        let paddingRight: number = parseFloat(containerStyle.paddingRight);
        let containerWidthNoPadding: number = container.clientWidth - paddingLeft - paddingRight;
        let distance: number = containerWidthNoPadding - element.offsetWidth;
        
        this.translateXToRightAnimation = animate(selector, {
            translateX: distance,
            duration: 1000,
            ease: "outQuad",
            autoplay: false,
        });
    }
    
    public playTranslateXToRight(): void {
        if (this.translateXToRightAnimation) {
            this.translateXToRightAnimation.play();
        }
    }
    
    public resetTranslateXToRight(): void {
        if (this.translateXToRightAnimation) {
            this.translateXToRightAnimation.reset();
        }
    }
    
    // Scale XY
    public initScaleXY(selector: string, containerSelector?: string): void {
        let container: HTMLElement | null;
        let element: HTMLElement | null = document.querySelector(selector);

        if (element !== null) {
            if (containerSelector) {
                container = document.querySelector(containerSelector) as HTMLElement;
            } else {
                container = element.parentElement as HTMLElement;
            }
        } else {
            return;
        }
        
        this.scaleXYAnimation = animate(selector, {
            scaleX: 3,
            scaleY: 3,
            rotate: 180,
            duration: 1000,
            ease: "outQuad",
            autoplay: false,
        });
    }
    
    public playScaleXY(): void {
        if (this.scaleXYAnimation) {
            this.scaleXYAnimation.play();
        }
    }
    
    public resetScaleXY(): void {
        if (this.scaleXYAnimation) {
            this.scaleXYAnimation.reset();
        }
    }
    
    // Timers and return to C#
    public initTimeDemoOnComplete(): void {
        let timer01Label: HTMLElement | null = document.getElementById("timer01Label");
        let timer01OnCompleteLabel: HTMLElement | null = document.getElementById("timer01OnCompleteLabel");

        if (timer01Label && timer01OnCompleteLabel) {
            this.timer01OnCompleteDemo = createTimer({
                autoplay: false,
                duration: 3000,
                onUpdate: self => timer01Label.innerHTML = self.currentTime.toString(),
                onComplete: self => {
                    timer01OnCompleteLabel.innerHTML = `${self.currentTime.toString()}`;
                    
                    if (this.timer01ResolveCallback) {
                        this.timer01ResolveCallback(self.currentTime);
                        this.timer01ResolveCallback = null;
                    }
                }
            });
        }
    }
    
    public playTimerOnComplete(): Promise<number> {
        if (this.timer01OnCompleteDemo) {
            return new Promise<number>((resolve) => {
                this.timer01ResolveCallback = resolve;
                this.timer01OnCompleteDemo?.play();
            });
        }
        
        return Promise.resolve(-1);
    }
    
    public resetTimerOnComplete(): void {
        let timer01Label: HTMLElement | null = document.getElementById("timer01Label");
        let timer01OnCompleteLabel: HTMLElement | null = document.getElementById("timer01OnCompleteLabel");
        
        if (this.timer01OnCompleteDemo && timer01Label && timer01OnCompleteLabel) {
            this.timer01OnCompleteDemo.reset();
            this.timer01ResolveCallback = null;
            timer01Label.innerHTML = "0";
            timer01OnCompleteLabel.innerHTML = "";
        }
    }
    
    public initTimeDemoThen(): void {
        let timer02Label: HTMLElement | null = document.getElementById("timer02Label");
        let timer02OnCompleteLabel: HTMLElement | null = document.getElementById("timer02ThenLabel");
        
        if (timer02Label && timer02OnCompleteLabel) {
            this.timer02ThenDemo = createTimer({
                autoplay: false,
                duration: 2500,
                onUpdate: self => timer02Label.innerHTML = self.currentTime.toString()
            });
            
            this.timer02ThenDemo.then(() => {
               timer02OnCompleteLabel.innerHTML = "Timer completed via then()";
               
               if (this.timer02ResolveCallback) {
                   this.timer02ResolveCallback(true);
                   this.timer02ResolveCallback = null;
               }
            });
        }
    }
    
    public playTimerThen(): Promise<boolean> {
        if (this.timer02ThenDemo) {
            return new Promise<boolean>((resolve) => {
                this.timer02ResolveCallback = resolve;
                this.timer02ThenDemo?.play();
            });
        }
        
        return Promise.resolve(false);
    }
    
    public resetTimerThen(): void {
        let timer02Label: HTMLElement | null = document.getElementById("timer02Label");
        let timer02ThenLabel: HTMLElement | null = document.getElementById("timer02ThenLabel");
        
        if (this.timer02ThenDemo && timer02Label && timer02ThenLabel) {
            this.timer02ThenDemo.reset();
            this.timer02ResolveCallback = null;
            timer02Label.innerHTML = "0";
            timer02ThenLabel.innerHTML = "";
        }
    }
}